// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"37":"3b18d974","313":"6f3d3382","531":"7a031fad","967":"2ed99612"}[chunkId] + ".css";
};